
import React, { useEffect, useState } from 'react'
import { Grid, Container, useMediaQuery } from '@material-ui/core';
import { ButtonAddHLPure, DropDownBtnHLPure, SearchBarHLPure, FilterHLPure, SimpleLoading, GridHLPure, GridSelectionHLPure } from '../../pures';
import './digital-vault-tracking.css'
import { filterBy, orderBy } from '@progress/kendo-data-query'
import { DigitalVaultDocumentAction } from '../../actions';
import { useTranslation } from 'react-i18next';

const initialFilter = {
    logic: "and",
    filters: [],
};

const initialSort = [
    {
        field: "date",
        dir: "desc",
    },
];

const DigitalVaultTrackingView = (props) => {
    const {
        selectedCompanyId,
        setSelectedCompanyId,
        documentLogsFiltered,
        isLoading,
        companies,
        selectedLog,
        setSelectedLog,
        events
    } = props
    const { t } = useTranslation()
    const isMobile = useMediaQuery("(max-width:820px)")

    const [documentLogs, setDocumentLogs] = useState([])
    const [eventFilterValue, setEventFilterValue] = useState(0)
    const [displayedLogs, setDisplayedLogs] = useState([]);

    const [filter, setFilter] = useState(initialFilter);
    const [customFilters, setCustomFilters] = useState([]);
    const [sort, setSort] = useState(initialSort);
    const [skip, setSkip] = useState(0);

    const showArrowBtn = useMediaQuery('(max-width: 960px)');
    const showMobile = useMediaQuery('(max-width: 560px)');

    useEffect(() => {
        let filters = []
        if (selectedCompanyId != "0") {
            filters.push({
                field: "companyId",
                operator: "eq",
                value: selectedCompanyId,
            })
        }
        if (eventFilterValue != 0) {
            filters.push({
                field: "eventId",
                operator: "eq",
                value: eventFilterValue,
            })
        }
        setCustomFilters(filters)
    }, [selectedCompanyId, eventFilterValue]);

    useEffect(() => {
        let completeFilter = {
            logic: "and",
            filters: [],
        }
        completeFilter.filters = filter ? filter.filters.concat(customFilters) : customFilters
        setDisplayedLogs(orderBy(filterBy(documentLogs, completeFilter), sort))
    }, [documentLogs, filter, customFilters, sort])

    useEffect(() => {
        setDocumentLogs(documentLogsFiltered)
    }, [documentLogsFiltered])

    const onCompanyDropdownChange = (e) => {
        setSelectedCompanyId(e.target.value)
    }

    const cellColumnOne = (props) => {
        return (
            <td
                style={props.style} // this applies styles that lock the column at a specific position
                className={props.className} // this adds classes needed for locked columns
                colSpan={props.colSpan}
                role={"gridcell"}
                aria-colindex={props.ariaColumnIndex}
                aria-selected={props.isSelected}
            >
                <span className="grid-cell-titles-margin-left">
                    {props.dataItem.eventDate}
                </span>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return (
            <td className=''>
                <span className="grid-cell-subtitles">
                    {props.dataItem.documentName}
                </span>
            </td>
        );
    };

    const cellColumnThree = (props) => {
        return (
            <td className=''>
                <span className="grid-cell-subtitles">
                    {props.dataItem.userName}
                </span>
            </td>
        );
    };

    const cellColumnFour = (props) => {
        return (
            <td className=''>
                <span className="grid-cell-subtitles">
                    {props.dataItem.eventName}
                </span>
            </td>
        );
    };

    const EventFilterCell = () => {
        return <div className="k-filtercell">
            <DropDownBtnHLPure
                optionsDropDown={events}
                onDropDownChange={(e) => setEventFilterValue(parseInt(e.target.value))}
                optionsValue={eventFilterValue}
                valueItem={"id"}
                nameOption={"name"}
            />
        </div>
    }

    // const handleSortDate = (e) => {
    //     // setSort(e.sort);
    //     let copyData = [...documentLogs]
    //     let newData = copyData.reverse()
    //     setDocumentLogs(newData)
    // }

    if (selectedLog) {
        return <DigitalVaultDocumentAction
            id={selectedLog.documentId}
            goBack={() => {
                const index = displayedLogs.findIndex(documentLog => documentLog.id == selectedLog.id);
                setSkip(Math.floor(index / 6) * 6);
                setSelectedLog(null);
            }}
            stateToMaintain={{ selectedLog, selectedCompanyId }}
        />
    }

    return (
        <Container
            disableGutters
            className="digitalVaultTracking-container"
        >
            {isLoading ? (
                <SimpleLoading />
            ) : (
                <>
                    <Grid
                        container
                        className="digitalVaultCategoriesAdministration-body"
                    >
                        {/*Container primera seccion de items, fila*/}
                        <Grid
                            item
                            xs={12}
                            className="digitalVaultTracking-navbar"
                        >
                            {/*Cada componente puro, estara envuelto en un grid item */}
                            <Grid
                                item
                                lg={3}
                                md={4}
                                xs={12}
                                sm={12}
                                className="digitalVaultTracking-filterHLPure "
                            >
                                {/* <FilterHLPure
                                        labelFilter="Filtrar por"
                                        options={props.filterOptions}
                                        nameOption="name"
                                        valueItem="companyId"
                                        optionsValue="companyId"
                                        onFilterChange={(e) => setSelectedValue(e.target.value)}
                                    /> */}

                                <DropDownBtnHLPure
                                    optionsDropDown={companies}
                                    optionsValue={selectedCompanyId}
                                    valueItem={"id"}
                                    nameOption={"companyName"}
                                    onDropDownChange={onCompanyDropdownChange}
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            className="digitalVaultCategoriesAdministration-gridContainer"
                        >
                            <GridSelectionHLPure
                                {...props}
                                dataGrid={displayedLogs}
                                skip={skip}
                                take={6}
                                //Filter
                                filter={filter}
                                filterable={true}
                                onFilterChange={e => setFilter(e.filter)}
                                hasLockedColumns={true}
                                //SORT?
                                sortable={true}
                                sort={sort}
                                onSortChange={(e) => { setSort(e.sort) }}
                                //1
                                titleRow1={t("digitalVaultTrackingView.grid.title1")}
                                filterableColumn1={false}
                                cellColumnOne={cellColumnOne}
                                isCheckedColOne={'date'}
                                lockedColumnOne={true}
                                widthColumnOne={showMobile ? "175px" : "250px"}
                                //2
                                columnTwo={!isMobile}
                                titleRow2={t("digitalVaultTrackingView.grid.title2")}
                                fieldColumn2={"documentName"}
                                cellColumnTwo={cellColumnTwo}
                                filterableColumn2={true}
                                widthColumnTwo={200}
                                //3
                                columnThree
                                titleRow3={t("digitalVaultTrackingView.grid.title3")}
                                fieldColumn3={"userName"}
                                cellColumnThree={cellColumnThree}
                                filterableColumn3={true}
                                widthColumnThree={200}
                                //4
                                columnFour
                                titleRow4={t("digitalVaultTrackingView.grid.title4")}
                                fieldColumn4={"eventName"}
                                cellColumnFour={cellColumnFour}
                                filterableColumn4={true}
                                filterCellColumn4={EventFilterCell}
                                widthColumnFour={200}
                                //5
                                columnFive
                                lockedColumnFive={true}
                                widthColumnFive={showArrowBtn ? "35px" : "150px"}
                                titleRow5={showArrowBtn ? "" : t("digitalVaultTrackingView.grid.title5")}
                                headerColumnFiveClass={"digitalVaultCategoriesAdministration-col5"}
                                columnFiveStyleClass={"digitalVaultCategoriesAdministration-col5"}
                                filterableColumn5={false}
                                labelOneActions={t("digitalVaultTrackingView.grid.button1")}
                                iconOneActive
                                activeDialog1
                                mobileFunction
                                btnOpenDialog1={(dataItem) => setSelectedLog(dataItem)}

                                onSelectedItem={() => { }}
                                setNameComponentUser={() => { }}
                                setShowDetails={() => { }}
                            />
                        </Grid>
                    </Grid>
                </>
            )}
        </Container>

    );

}

export default DigitalVaultTrackingView